import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import './router/config'
import store from './store'
import Antd from 'ant-design-vue'
//import 'ant-design-vue/dist/antd.css'
import 'ant-design-vue/dist/antd.less'
import 'core-js'
import 'regenerator-runtime/runtime'
import i18n from './i18n' // 引入上面创建的 i18n 实例
console.error = () => {}
createApp(App).use(store).use(router).use(Antd).use(i18n).mount('#app')
